export enum ObjectModelTriggerBasedOnType{
  ObjectModelProperty = 1,
  TimeBasedEvent = 2,
  Creation = 3,
  Modification = 4,
  Deletion = 5,
}